const ApiEndPoints = {
    GET_TASK_INSTANCE: '/get_task_instance'
}
export default ApiEndPoints;